import { render, staticRenderFns } from "./inputBox.vue?vue&type=template&id=25aff3aa&scoped=true"
import script from "./inputBox.vue?vue&type=script&lang=js"
export * from "./inputBox.vue?vue&type=script&lang=js"
import style0 from "./inputBox.vue?vue&type=style&index=0&id=25aff3aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aff3aa",
  null
  
)

export default component.exports